var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',[_vm._v("Nastavení")]),_c('div',[_c('b-nav',{attrs:{"tabs":""}},_vm._l((_vm.settingItems),function(item,index){return _c('b-nav-item',{key:index,attrs:{"to":item.to}},[_vm._v("\n        "+_vm._s(item.name)+"\n      ")])}),1)],1),_c('div',{staticClass:"p-3"},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }